const useGTM = {
  pushEvent: (event) => {
    if (window?.dataLayer) {
      window.dataLayer.push(event);
    }
  },

  async handlePaymentSuccess(router, axios) {
    // Parse query parameters from both regular query and hash-based query
    const routerQuery = router.currentRoute.value.query;
    const hashQuery = this.parseHashQuery();
    const currentQuery = { ...routerQuery, ...hashQuery };

    // Check for Stripe payments (sessionId) or crypto payments (transactionId)
    const sessionId = Array.isArray(currentQuery.sessionId)
      ? currentQuery.sessionId[0]
      : currentQuery.sessionId;
    const transactionId = Array.isArray(currentQuery.transactionId)
      ? currentQuery.transactionId[0]
      : currentQuery.transactionId;
    const value = currentQuery.value
      ? Array.isArray(currentQuery.value)
        ? currentQuery.value[0]
        : currentQuery.value
      : null;

    if (sessionId && value) {
      // Stripe payment - get transaction details from backend
      try {
        const response = await axios.get(
          `/api/payments/transaction-details?session_id=${sessionId}`,
        );

        if (response.data.success) {
          const { data } = response.data;

          // Extract transaction ID from response (could be from payment_intent, invoice, or subscription)
          let finalTransactionId = data.session_id;
          if (data.payment_intent?.id) {
            finalTransactionId = data.payment_intent.id;
          } else if (data.invoice?.id) {
            finalTransactionId = data.invoice.id;
          } else if (data.subscription?.id) {
            finalTransactionId = data.subscription.id;
          }

          await this.sendPurchaseEvent(currentQuery, finalTransactionId);
        } else {
          // console.error("❌ Failed to get transaction details");
        }
      } catch (error) {
        // console.error("❌ Error fetching transaction details:", error);
      }
    } else if (transactionId && value) {
      await this.sendPurchaseEvent(currentQuery, transactionId);
    } else {
      // console.log("❌ No valid payment parameters found");
      // console.groupEnd();
      return;
    }

    // Clean up URL
    this.cleanupUrl(router, currentQuery);
    // console.groupEnd();
  },

  async sendPurchaseEvent(currentQuery, finalTransactionId) {
    const valueStr = Array.isArray(currentQuery.value) ? currentQuery.value[0] : currentQuery.value;
    const currency = Array.isArray(currentQuery.currency)
      ? currentQuery.currency[0]
      : currentQuery.currency || "EUR";
    const itemId = Array.isArray(currentQuery.item_id)
      ? currentQuery.item_id[0]
      : currentQuery.item_id;
    const itemName = Array.isArray(currentQuery.item_name)
      ? currentQuery.item_name[0]
      : currentQuery.item_name || "LegalTorch Subscription";
    const itemCategory = Array.isArray(currentQuery.item_category)
      ? currentQuery.item_category[0]
      : currentQuery.item_category || "subscription";
    const subscriptionType = Array.isArray(currentQuery.subscription_type)
      ? currentQuery.subscription_type[0]
      : currentQuery.subscription_type;

    this.pushEvent({
      event: "purchase",
      transaction_id: finalTransactionId,
      value: parseFloat(valueStr) || 0,
      currency,
      items: [
        {
          item_id: itemId,
          item_name: itemName,
          item_category: itemCategory,
          item_variant: subscriptionType,
          quantity: 1,
          price: parseFloat(valueStr) || 0,
        },
      ],
    });
  },

  parseHashQuery() {
    const hash = window.location.hash;
    if (!hash.includes("?")) return {};

    const queryString = hash.split("?")[1];
    const params = new URLSearchParams(queryString);
    const result = {};

    for (const [key, value] of params) {
      result[key] = value;
    }

    return result;
  },

  cleanupUrl(router, currentQuery) {
    // Clean up both router query and hash query
    const cleanRouterQuery = { ...router.currentRoute.value.query };
    delete cleanRouterQuery.sessionId;
    delete cleanRouterQuery.transactionId;
    delete cleanRouterQuery.value;
    delete cleanRouterQuery.currency;
    delete cleanRouterQuery.item_id;
    delete cleanRouterQuery.item_name;
    delete cleanRouterQuery.item_category;
    delete cleanRouterQuery.subscription_type;

    // Clean up hash query parameters
    const hash = window.location.hash;
    let cleanHash = router.currentRoute.value.hash;

    if (hash.includes("?")) {
      const hashBase = hash.split("?")[0];
      const queryString = hash.split("?")[1];
      const params = new URLSearchParams(queryString);

      // Remove payment-related parameters
      params.delete("sessionId");
      params.delete("transactionId");
      params.delete("value");
      params.delete("currency");
      params.delete("item_id");
      params.delete("item_name");
      params.delete("item_category");
      params.delete("subscription_type");
      params.delete("productType");
      params.delete("serviceName");
      params.delete("amount");

      // Rebuild hash
      const remainingParams = params.toString();
      cleanHash = remainingParams ? `${hashBase}?${remainingParams}` : hashBase;
    }

    router.replace({
      path: router.currentRoute.value.path,
      hash: cleanHash,
      query: cleanRouterQuery,
    });
  },
};

export default useGTM;
